"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.avatar.exceeded': '已达到头像限制。升级您的计划以创建更多头像。',
    'limits.avatar.limitReached': '头像限制：{limit}（升级以创建更多）',
};
